export class FreelancerProfilePaths {
	// Onboarding
	static readonly CURRENT_ONBOARDING_FORM_STEP = "/onboarding/formsProgress/currentStep";

	// Basic Profile Information
	static readonly TITLE = "/title";
	static readonly EXPERTISE_ID = "/expertiseId";
	static readonly EXPERIENCE_ID = "/experienceId";
	static readonly FREELANCING_YEARS_OF_EXPERIENCE_ID = "/freelancingYearsOfExperienceId";

	// Skills and Tools
	static readonly SKILLS = "/skills";
	static readonly TOOLS = "/tools";
	static readonly REGIONS = "/regions";

	// Freelancer Information
	static readonly FREELANCER_LANGUAGES = "/freelancer/languages";
	static readonly FREELANCER_USER_FIRST_NAME = "/freelancer/user/firstName";
	static readonly FREELANCER_USER_LAST_NAME = "/freelancer/user/lastName";
	static readonly FREELANCER_PHONE_NUMBER = "/freelancer/phoneNumber";
	static readonly FREELANCER_ADDRESS = "/freelancer/address";
	static readonly FREELANCER_PICTURE = "/freelancer/picture";

	// Sectors and Business Domains
	static readonly SECTORS = "/sectors";
	static readonly BUSINESS_DOMAINS = "/businessDomains";

	// Presentation
	static readonly PRESENTATION = "/presentation";
	static readonly IS_TRAINER = "/isTrainer";
	static readonly PROFESSIONAL_EXPERIENCES = "/professionalExperiences";

	// Availability
	static readonly AVAILABILITY = "/availability";

	// Professional Information
	static readonly DAILY_RATE_MIN = "/dailyRateMin";
	static readonly DAILY_RATE_MAX = "/dailyRateMax";
	static readonly MISSIONS_PREFERRED_DURATION_ID = "/missionsPreferredDurationId";
	static readonly JOB_PREFERRED_LOCATION_ID = "/jobPreferredLocationId";
	static readonly COMPANY = "/company";
	static readonly DOCUMENTS = "/documents";
	static readonly URLS = "/urls";
}
